/**
 * signInLink: a dashboard sign-in link that fills in the email for whoever
 * taps it.
 * ─────────────────────────────────────────────────────────────────────────────
 * Sign-in details handed over in WhatsApp were hard to use: WhatsApp copies a
 * whole message, not a line of it, so the vendor could copy neither the email
 * nor the password on its own (Izi, 4 Oct 2026). The hand-over now sends a
 * link that fills the email in, and the password as a message of its own.
 *
 * The email rides after "#": the browser never sends that part to the server,
 * so it does not land in a request log, and the sign-in page clears it from
 * the address bar once read (views/Pages/Login.js). Only the email ever goes
 * in a link, never a password.
 */

export const SIGN_IN_EMAIL_PARAM = "email";

const EMAIL_SHAPE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** "https://lusuku.shop/auth/login-page#email=ady%40shop.ug", or the plain link. */
export const signInLinkFor = (loginUrl, email) => {
  const base = String(loginUrl || "").split("#")[0];
  const value = String(email || "").trim();
  if (!base) return "";
  return EMAIL_SHAPE.test(value)
    ? `${base}#${SIGN_IN_EMAIL_PARAM}=${encodeURIComponent(value)}`
    : base;
};

/** The email a sign-in link carries ("#email=..."), or "" when there is none. */
export const emailFromSignInLink = (hash) => {
  try {
    const params = new URLSearchParams(String(hash || "").replace(/^#/, ""));
    const value = (params.get(SIGN_IN_EMAIL_PARAM) || "").trim();
    return value.length <= 254 && EMAIL_SHAPE.test(value) ? value : "";
  } catch (_err) {
    return "";
  }
};
